export enum SearchBy {
  APARTMENT_NUMBER = 'apartmentNumber',
  EMAIL = 'email',
  FULL_NAME = 'fullName',
  NAME = 'name',
  SELLER = 'seller',
  TITLE = 'title'
}
